import React from 'react';
import { compose, map, sort } from 'ramda';
import { reduxForm, InjectedFormProps, Form } from 'redux-form';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import WizardCard from 'components/WizardCard/WizardCard';
import Fields from 'components/Fields';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { PreviousStepType } from 'components/Wizard/Wizard';
import IntlProvider, {
  useFormatMessage,
  IntlProviderType,
  getLabelByIntlPrefix,
} from 'components/IntlProvider';

import { validate, wizardStyles } from './wizardUtils';

const { connect, selectors } = StoreProvider;

interface GoalType {
  id: number;
  value: string;
  label: string;
}

interface ProductResearchGoalProps extends PreviousStepType {
  goals: GoalType[];
  setSubcategories: (data: object) => void;
  intl: IntlProviderType;
}

const ProductResearchGoal = ({
  handleSubmit,
  error,
  goals,
  previousStep,
}: ProductResearchGoalProps & InjectedFormProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();
  return (
    <WizardCard>
      <Form onSubmit={handleSubmit} className={classes.form} noValidate>
        <Grid item xs={12}>
          <Typography
            component="h1"
            variant="h5"
            color="inherit"
            className={classes.title}
          >
            {t(
              'forms.wizard.researchgoal',
              'What level of accuracy do you require for this test?'
            )}
          </Typography>
          <Fields.Wizard.ResearchGoal goals={goals} />
          {error && <FormHelperText error>{error}</FormHelperText>}
          <Button
            classes={{
              root: classes.submitButton,
            }}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('fields.wizard.common.continue', 'Continue')}
          </Button>
          <Button
            onClick={previousStep}
            classes={{
              root: classes.secondaryButton,
            }}
            color="secondary"
          >
            {t('fields.wizard.common.back', 'Back')}
          </Button>
        </Grid>
      </Form>
    </WizardCard>
  );
};

export default compose(
  IntlProvider.withIntl,
  connect((state, props: ProductResearchGoalProps) => ({
    goals: compose(
      map((gola: GoalType) => ({
        ...gola,
        value: gola.id.toString(),
        label: getLabelByIntlPrefix(gola, props.intl.locale, 'label'),
      })),
      sort((a: GoalType, b: GoalType) => a.id - b.id)
    )(selectors.assistantSelectors.goals(state)),
  })),
  reduxForm({
    form: 'wizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(ProductResearchGoal);
